import React from "react";
import { BlockStack, Button, InlineStack, Text } from "@shopify/polaris";

/**
 * Editor shell matching reference app layout: Polaris nav buttons + grey scroll body.
 */
export default function EditorShell({ nav, activeId, onNavChange, hint, headerAction, children }) {
  return (
    <BlockStack gap="300">
      <div className="fsb-editor-panel">
        <div className="fsb-editor-panel__header">
          <div className="fsb-editor-panel__header-row">
            <InlineStack gap="100" blockAlign="center" wrap>
              {nav.map((item) => (
                <Button
                  key={item.id}
                  variant={activeId === item.id ? "primary" : "secondary"}
                  onClick={() => onNavChange(item.id)}
                  icon={item.icon}
                >
                  {item.label}
                </Button>
              ))}
            </InlineStack>
            {headerAction ? (
              <div className="fsb-editor-panel__header-action">{headerAction}</div>
            ) : null}
          </div>
          {hint ? (
            <div className="fsb-editor-panel__hint">
              <Text as="p" variant="bodySm" tone="subdued">
                {hint}
              </Text>
            </div>
          ) : null}
        </div>

        <div className="fsb-editor-panel__body">
          <BlockStack gap="300">{children}</BlockStack>
        </div>
      </div>
    </BlockStack>
  );
}
